import { Component } from '@angular/core';

import { PortalNavbarComponent } from '../portal-navbar/portal-navbar.component';
import { RouterModule } from '@angular/router';
import { PortalFooterComponent } from '../portal-footer/portal-footer.component';

@Component({
  selector: 'app-portal-base-layout',
  imports: [PortalNavbarComponent, PortalFooterComponent, RouterModule],
  templateUrl: './portal-base-layout.component.html',
})
export class PortalBaseLayoutComponent {}
